interface Vehicle {
  id: number;
  name: string;
  descriptor: string;
  badge?: string;
  featured: boolean;
  credit: string;
  installment: string;
  term: string;
  image: string;
}

const VEHICLES: Vehicle[] = [
  {
    id: 1,
    name: 'Audi Q3 2026',
    descriptor: 'Curadoria Premium · Linha Q',
    badge: undefined,
    featured: true,
    credit: 'R$ 400.000,00',
    installment: 'R$ 5.900,00',
    term: '80 meses',
    image: 'https://storage.readdy-site.link/project_files/cde8128b-6de1-46ae-a588-692dddd7b4aa/e9b4aea7-02f2-44c1-8959-9434265cbf81_Audi-Q3-2026.jpg?v=c52ea8faf10c5b8ac14599549f006d2e',
  },
  {
    id: 2,
    name: 'Volvo EX30',
    descriptor: 'Mobilidade Elétrica · Referência Escandinava',
    badge: 'Elétrico de destaque',
    featured: true,
    credit: 'R$ 240.000,00',
    installment: 'R$ 3.700,00',
    term: '80 meses',
    image: 'https://storage.readdy-site.link/project_files/cde8128b-6de1-46ae-a588-692dddd7b4aa/1803e448-4125-47c8-a8a0-137e9f0bca34_volvlo-EX-30_2026.jpeg?v=0f16f4b6c6ed9781ae1ee67e283247f6',
  },
  {
    id: 3,
    name: 'VW Tiguan 2026',
    descriptor: 'Engenharia Alemã · Valor Patrimonial',
    badge: undefined,
    featured: false,
    credit: 'R$ 300.000,00',
    installment: 'R$ 4.500,00',
    term: '80 meses',
    image: 'https://storage.readdy-site.link/project_files/cde8128b-6de1-46ae-a588-692dddd7b4aa/3c47f934-08e7-438f-a81c-eaac858ed5b9_vw-tiguan_2026_r-line.jpg?v=f1d4bcfdb2e46b5b02ba0b5e311e8e5e',
  },
  {
    id: 4,
    name: 'Jeep Compass Série S T270',
    descriptor: 'Edição Seletiva · Curadoria Utilitária',
    badge: undefined,
    featured: false,
    credit: 'R$ 236.990,00',
    installment: 'R$ 3.600,00',
    term: '80 meses',
    image: 'https://storage.readdy-site.link/project_files/cde8128b-6de1-46ae-a588-692dddd7b4aa/ec6ffdd7-ccf7-4298-b6f3-93cb02eb8c0b_COMPASS-1.3-SERIE-S-T270-16V-TURBO-FLEX-4P-AUTOMTICO_2026.jpg?v=c944e50425049698a4b7ee107c69a71a',
  },
  {
    id: 5,
    name: 'Renault Boreal Iconic',
    descriptor: 'Premium Percebido · Curadoria Contemporânea',
    badge: undefined,
    featured: false,
    credit: 'R$ 214.990,00',
    installment: 'R$ 3.300,00',
    term: '80 meses',
    image: 'https://public.readdy.ai/ai/img_res/eb63a4e6de33958d38b3c542b5059c68.jpg',
  },
  {
    id: 6,
    name: 'CAOA Changan Uni-T',
    descriptor: 'Tecnologia Emergente · Acesso Estruturado',
    badge: undefined,
    featured: false,
    credit: 'R$ 169.990,00',
    installment: 'R$ 2.400,00',
    term: '80 meses',
    image: 'https://readdy.ai/api/search-image?query=Changan%20UniT%20modern%20premium%20crossover%20SUV%20in%20dark%20midnight%20navy%20blue%20or%20deep%20charcoal%20metallic%2C%20contemporary%20premium%20automotive%20design%20editorial%20photography%2C%20clean%20dark%20gradient%20seamless%20background%2C%20three-quarter%20front%20view%2C%20sophisticated%20refined%20composition%2C%20no%20people%2C%20commercial%20automotive%20photography%20quality%2C%20aspirational%20modern%20crossover&width=600&height=400&seq=auto_chaganunit_fgt_v1&orientation=landscape',
  },
];

const WA_NUMBER = '5511930322408';

interface FinancialMetricProps {
  label: string;
  value: string;
}

function FinancialMetric({ label, value }: FinancialMetricProps) {
  return (
    <div>
      <p className="text-xs text-stone-400 uppercase tracking-wider mb-0.5">{label}</p>
      <p className="text-sm font-medium text-stone-800">{value}</p>
    </div>
  );
}

interface CardCTAProps {
  vehicle: Vehicle;
  variant?: 'solid' | 'outline';
}

function CardCTA({ vehicle, variant = 'solid' }: CardCTAProps) {
  const handleClick = () => {
    const msg = `Olá! Gostaria de uma análise de aquisição patrimonial via consórcio para o ${vehicle.name}. Crédito de referência: ${vehicle.credit}.`;
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  if (variant === 'outline') {
    return (
      <button
        onClick={handleClick}
        className="w-full mt-4 border border-stone-300 text-stone-700 text-sm py-2.5 rounded-lg hover:bg-stone-900 hover:text-white hover:border-stone-900 transition-all duration-300 whitespace-nowrap cursor-pointer font-medium tracking-wide"
      >
        Solicitar análise
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="w-full mt-5 bg-stone-900 text-white text-sm py-3 rounded-lg hover:bg-stone-700 transition-all duration-300 whitespace-nowrap cursor-pointer font-medium tracking-wide flex items-center justify-center gap-2"
    >
      Solicitar análise
      <i className="ri-arrow-right-line text-xs"></i>
    </button>
  );
}

interface FeaturedCardProps {
  vehicle: Vehicle;
}

function FeaturedVehicleCard({ vehicle }: FeaturedCardProps) {
  return (
    <div className="bg-white rounded-2xl overflow-hidden group transition-all duration-500 hover:-translate-y-1 border border-stone-100">
      {/* Image */}
      <div className="relative h-72 overflow-hidden">
        <img
          src={vehicle.image}
          alt={vehicle.name}
          className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
        {vehicle.badge && (
          <div className="absolute top-4 left-4">
            <span className="bg-stone-900/80 backdrop-blur-sm text-amber-300 text-xs px-3 py-1.5 rounded-full font-medium tracking-wider uppercase">
              {vehicle.badge}
            </span>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-7">
        {/* Name + descriptor */}
        <div className="mb-5">
          <h3 className="text-xl font-semibold text-stone-900 mb-1 font-serif group-hover:text-amber-700 transition-colors duration-300">
            {vehicle.name}
          </h3>
          <p className="text-xs text-stone-400 uppercase tracking-widest">{vehicle.descriptor}</p>
        </div>

        {/* Amber accent line */}
        <div className="w-8 h-px bg-amber-400 mb-5" />

        {/* Financial metrics */}
        <div className="grid grid-cols-3 gap-4 mb-1">
          <FinancialMetric label="Crédito" value={vehicle.credit} />
          <FinancialMetric label="Parcela ref." value={vehicle.installment} />
          <FinancialMetric label="Prazo" value={vehicle.term} />
        </div>

        <CardCTA vehicle={vehicle} variant="solid" />
      </div>
    </div>
  );
}

interface StandardCardProps {
  vehicle: Vehicle;
}

function StandardVehicleCard({ vehicle }: StandardCardProps) {
  return (
    <div className="bg-white rounded-xl overflow-hidden group transition-all duration-500 hover:-translate-y-1 border border-stone-100">
      {/* Image */}
      <div className="relative h-52 overflow-hidden">
        <img
          src={vehicle.image}
          alt={vehicle.name}
          className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
      </div>

      {/* Body */}
      <div className="p-6">
        {/* Name + descriptor */}
        <h3 className="text-base font-semibold text-stone-900 mb-0.5 group-hover:text-amber-700 transition-colors duration-300 leading-tight">
          {vehicle.name}
        </h3>
        <p className="text-xs text-stone-400 uppercase tracking-wider mb-4">{vehicle.descriptor}</p>

        {/* Subtle amber accent */}
        <div className="w-6 h-px bg-amber-300 mb-4" />

        {/* Financial metrics — stacked */}
        <div className="space-y-3 border-t border-stone-100 pt-4">
          <FinancialMetric label="Crédito" value={vehicle.credit} />
          <FinancialMetric label="Parcela ref." value={vehicle.installment} />
          <FinancialMetric label="Prazo" value={vehicle.term} />
        </div>

        <CardCTA vehicle={vehicle} variant="outline" />
      </div>
    </div>
  );
}

export default function AutomotiveShowcase() {
  const featured = VEHICLES.filter((v) => v.featured);
  const standard = VEHICLES.filter((v) => !v.featured);

  return (
    <div>
      {/* Intro */}
      <div className="text-center mb-8">
        <span className="text-xs text-amber-700 uppercase tracking-widest font-medium">
          Curadoria Automotiva
        </span>
        <p className="mt-3 text-stone-500 max-w-xl mx-auto text-sm leading-relaxed">
          Veículos selecionados para clientes que buscam sofisticação, patrimônio e estrutura financeira mais inteligente.
        </p>
      </div>

      {/* Framing note */}
      <p className="text-center text-xs text-stone-400 max-w-2xl mx-auto leading-relaxed mb-10 italic">
        Modelos selecionados com simulações referenciais para clientes que buscam aquisição patrimonial com maior sofisticação.
      </p>

      {/* Featured Duo */}
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        {featured.map((vehicle) => (
          <FeaturedVehicleCard key={vehicle.id} vehicle={vehicle} />
        ))}
      </div>

      {/* Standard Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        {standard.map((vehicle) => (
          <StandardVehicleCard key={vehicle.id} vehicle={vehicle} />
        ))}
      </div>

      {/* Disclaimer */}
      <div className="text-center border-t border-stone-100 pt-8">
        <p className="text-xs text-stone-400 tracking-wide leading-relaxed">
          Imagens ilustrativas. Simulações referenciais sujeitas à estrutura da operação, disponibilidade e análise.
        </p>
      </div>
    </div>
  );
}
